module.exports = "<blockquote class=\"p-b-0 p-t-0 m-b-5\" [ngClass]=\"inClass\">\n    <p class=\"font-13 m-b-0\" style=\"text-transform: uppercase\"><b translate>{{label}}</b></p>\n    <p class=\"font-15 m-t-0\" [innerHTML]=\"text\"></p>\n</blockquote>"


//////////////////
// WEBPACK FOOTER
// ./src/app/control-core/shared/block-quote/block-quote.component.html
// module id = ./src/app/control-core/shared/block-quote/block-quote.component.html
// module chunks = main